import { ReactNode } from "react";

import * as styledElements from "./RadioButtonStyles";

const RadioButton = ({
  id,
  name,
  checked,
  onChange,
  styleProps,
  label,
}: {
  id?: string;
  name?: string;
  checked?: boolean;
  onChange?: () => void;
  styleProps?: object;
  label?: ReactNode;
}) => {
  return (
    <styledElements.Container
      style={styleProps}
      onClick={onChange}
      checked={checked}
    >
      <input id={id} type="radio" name={name} />
      <label htmlFor={id}>{label}</label>
    </styledElements.Container>
  );
};

export default RadioButton;
